import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class WarehouseLocalizationUpdateRequest {
  @jsonMember(String)
  public label!: string;

  @jsonMember(Number)
  public position!: number;

  public constructor(label: string, position: number) {
    this.label = label;
    this.position = position;
  }
}
